import type { Repo } from '@/services/githubApi';

/**
 * Whether a repository matches a typed filter. Case-insensitive; every
 * whitespace-separated word must appear in the repository's full name or its
 * description, so "docs company" finds `puglieseweb/docs-company` and
 * "evrella reminders" finds the repo whose description says both. An empty
 * or blank query matches everything.
 */
export function matchesRepoQuery(
  repo: Pick<Repo, 'full_name' | 'description'>,
  query: string,
): boolean {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = `${repo.full_name} ${repo.description ?? ''}`.toLowerCase();
  return words.every((w) => haystack.includes(w));
}
